module.exports = __webpack_public_path__ + "img/image_14.df322086.png";